module.exports = __webpack_public_path__ + "assets/img/5_4.166661d7.png";